import { fetchPortfolioItems } from '@utils/contentful'
import { shuffleArray } from '@utils/shuffleArray'
import { Container } from '@components/Container/Container'
import { Filters } from '@components/Filters/Filters'
import Masonry from 'react-masonry-css'
import { PortfolioItem } from '@components/PortfolioItem/PortfolioItem'
import styles from '@styles/portfolio.module.scss'
import { GetStaticProps } from 'next'
import { Categories, PortfolioItem as PortfolioItemType } from '@types'

const Portfolio = ({ items }) => {
  const shuffledItems = shuffleArray(items)
  return (
    <main className={styles.portfolio}>
      <Container additionalStyles={styles.wrapper}>
        <Filters
          categories={[
            Categories.ANIMATION,
            Categories.GRAPHIC,
            Categories.ILLUSTRATION,
            Categories.UIUX,
          ]}
        />
      </Container>
      <Masonry
        breakpointCols={{
          default: 3,
          992: 2,
          768: 1,
        }}
        className="masonryGrid"
        columnClassName="masonryColumn"
      >
        {shuffledItems.map((item, i) => {
          return <PortfolioItem item={item as PortfolioItemType} key={i} />
        })}
      </Masonry>
    </main>
  )
}

export const getStaticProps: GetStaticProps = async () => {
  const res = await fetchPortfolioItems()
  const items = await res.map((item) => {
    return {
      id: item.sys.id,
      fields: item.fields,
    }
  })

  return {
    props: {
      items,
    },
  }
}

export default Portfolio
